<template>
    <div class="hotPred-wrapper" v-if="listHotData.length > 0">
        <div class="hotPred-content">
            <div class="hotPred-title">
                <i class="hotPred-title-i"></i>
                <span>Hot Match Predictions</span>
                <i class="hotPred-title-tips" @click="hotTipsIsShow()"></i>
            </div>
            <div class="hotPred-box">
                <div :class="['leftBtn', {hide: !ishideLeft}]" @click="swipePrev()"></div>

                <div class="hotPred-list-box">
                    <ul class="hotPred-list" ref="topNewsList">
                        <li class="hotPred-item" :ref="'swiperItem_' + index" v-for="(item, index) in listHotData" :key="index">
                            <router-link :to="toDetails(item)" @click.native="googleEventClick(item)">
                                <!-- <div class="hp-league" :data-id="item['league']['id']">
                                    <span class="hp-league-logo"><img :src="common.leagueImgGet(item['league']['id'], 16)" @error="common.imgError($event, 'team')" /></span>
                                    <span class="hp-league-name">{{ item['league']['shortName'] }}</span>
                                    <span class="hp-league-time">{{ matchTime(item['match']['startTime']) }}</span>
                                </div> -->
                                <div class="hp-team">
                                    <span class="hp-home-logo"><img :src="common.teamImgGet(item['match']['homeTeam']['id'], 16)" @error="common.imgError($event, 'team')" /></span>
                                    <span class="hp-home-name">{{ item['match']['homeTeam']['fullName'] }}</span>
                                    <span class="hp-away-logo"><img :src="common.teamImgGet(item['match']['awayTeam']['id'], 16)" @error="common.imgError($event, 'team')" /></span>
                                    <span class="hp-away-name">{{ item['match']['awayTeam']['fullName'] }}</span>
                                    <span class="hp-time" v-html="matchTime(item['match']['startTime'])"></span>
                                </div>
                                <template v-if="isModelShow(item['predScore'])">
                                    <div class="hp-goals" v-if="item['predScore']['score']">
                                        <span class="hp-goals-title"><i>{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][4] }}</i></span>
                                        <span class="hp-goals-result">
                                            <b v-for="(val, i) in item['predScore']['score']" :key="i">{{ val == '1d' ? langConfig.txtLang[langConfig.curLang]['OTHERS'] : val.replace('-', ':') }}</b>
                                        </span>
                                        <div class="hp-type">{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE2'][0] }}</div>
                                    </div>
                                    <div class="hp-goals" v-if="item['predScore']['total']">
                                        <span class="hp-goals-title"><i>{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][1] }}</i></span>
                                        <span class="hp-goals-result">
                                            <b v-for="(val, i) in item['predScore']['total']" :key="i">{{ val > 1 ? langConfig.index[langConfig.curLang]['HOT_PRED']['GOALS'].replace('?1', val) :  langConfig.index[langConfig.curLang]['HOT_PRED']['GOAL'].replace('?1', val) }}</b>
                                        </span>
                                        <div class="hp-type">{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE2'][0] }}</div>
                                    </div>
                                </template>
                                <template v-if="isModelShow(item['predWdl'])">
                                    <div class="hp-goals">
                                        <span class="hp-goals-title"><i>{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][2] }}</i></span>
                                        <span class="hp-goals-result">
                                            <b v-if="item['predWdl']['win']">{{ langConfig.index[langConfig.curLang]['HOT_PRED']['WIN'][0] }}</b>
                                            <b v-if="item['predWdl']['draw']">{{ langConfig.index[langConfig.curLang]['HOT_PRED']['WIN'][1] }}</b>
                                            <b v-if="item['predWdl']['loss']">{{ langConfig.index[langConfig.curLang]['HOT_PRED']['WIN'][2] }}</b>
                                        </span>
                                        <div class="hp-type">{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE2'][1] }}</div>
                                    </div>
                                </template>
                                <template v-if="isModelShow(item['predDiffer'])">
                                    <!-- <div class="hp-ah">
                                        <div class="hp-ah-item">
                                            <div class="hp-ah-result">
                                                <span class="hp-draw" v-if="item['predDiffer']['wdl'] == 2">Draw</span>
                                                <span class="hp-img" v-if="item['predDiffer']['wdl'] != 2"><img :src="common.teamImgGet(diffTeamLogo(item, 0), 20)" @error="common.imgError($event, 'team')" /></span>
                                                <span class="hp-txt" v-if="false">{{ item['predDiffer']['wdlRate'] }}</span>
                                            </div>
                                            <div class="hp-ah-title">{{ langConfig.index[langConfig.curLang]['HOT_PRED']['HP_ODDS'][2] }}</div>
                                        </div>
                                        <div class="hp-ah-item">
                                            <div class="hp-ah-result">
                                                <span class="hp-img"><img :src="common.teamImgGet(diffTeamLogo(item, 1), 20)" @error="common.imgError($event, 'team')" /></span>
                                                <span class="hp-txt" v-if="false">{{ item['predDiffer']['ahVal'] }}</span>
                                            </div>
                                            <div class="hp-ah-title">{{ langConfig.index[langConfig.curLang]['HOT_PRED']['HP_ODDS'][0] }}({{ item['predDiffer']['ahHand'] }})</div>
                                        </div>
                                        <div class="hp-ah-item">
                                            <div class="hp-ah-result">
                                                <span class="hp-ou-txt" v-html="hpOUTxt(item)"></span>
                                            </div>
                                            <div class="hp-ah-title">{{ langConfig.index[langConfig.curLang]['HOT_PRED']['HP_ODDS'][1] }}</div>
                                        </div>
                                    </div> -->
                                    <div class="hp-goals" v-if="item['predDiffer']['ah']">
                                        <span class="hp-goals-title"><i>{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][5] }}</i></span>
                                        <span class="hp-goals-result">
                                            <b v-html="diffAsianResult(item)"></b>
                                        </span>
                                        <div class="hp-type">{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE2'][2] }}</div>
                                    </div>
                                    <div class="hp-goals" v-if="item['predDiffer']['ou']">
                                        <span class="hp-goals-title"><i>{{ langConfig.index[langConfig.curLang]['PLAY_TITLE'][3] }}</i></span>
                                        <span class="hp-goals-result">
                                            <b v-html="hpOUTxt(item)"></b>
                                        </span>
                                        <div class="hp-type">{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE2'][2] }}</div>
                                    </div>
                                </template>
                                <div class="hp-odds" v-if="item['asian']">
                                    <span class="hp-odds-title"><i>{{ langConfig.index[langConfig.curLang]['HOT_PRED']['HP_ODDS'][0] }}</i></span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 0, 0)">{{ oddsCallFn(2, item['asian']['home'], 'home') }}</span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 0, 1)">{{ oddsCallFn(2, item['asian']['hand'], 'hand') }}</span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 0, 2)">{{ oddsCallFn(2, item['asian']['away'], 'away') }}</span>
                                </div>
                                <div class="hp-odds" v-if="item['total']">
                                    <span class="hp-odds-title"><i>{{ langConfig.index[langConfig.curLang]['HOT_PRED']['HP_ODDS'][1] }}</i></span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 1, 0)">{{ oddsCallFn(3, item['total']['over'], 'over') }}</span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 1, 1)">{{ oddsCallFn(3, item['total']['total'], 'total') }}</span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 1, 2)">{{ oddsCallFn(3, item['total']['under'], 'under') }}</span>
                                </div>
                                <div class="hp-odds" v-if="item['threeWay']">
                                    <span class="hp-odds-title"><i>{{ langConfig.index[langConfig.curLang]['HOT_PRED']['HP_ODDS'][2] }}</i></span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 2, 0)">{{ oddsCallFn(1, item['threeWay']['home'], 'home') }}</span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 2, 1)">{{ oddsCallFn(1, item['threeWay']['draw'], 'draw') }}</span>
                                    <span class="hp-odds-num" :class="oddsUd(item, 2, 2)">{{ oddsCallFn(1, item['threeWay']['away'], 'away') }}</span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>

                <div :class="['rightBtn', {hide: !ishideRight}]" @click="swipeNext()"></div>
            </div>
        </div>

        <van-popup v-model="hotTipsShow" class="van-popup-m"
        :closeable="false"
        :position="screenWidth>767?'center':'bottom'" 
        get-container="#app">
            <div class="intro-tips-box">
                <div class="intro-tips-top">
                    <h4>Hot Match Prediction Instructions</h4>
                    <span class="intro-tips-close" @click="hotTipsIsShow()"></span>
                </div>
                <div class="intro-main">
                    <div class="intro-dec">We've carefully selected 10 matches that have not yet been finished with high prediction accuracy for your quick reference.<br />Different model algorithms provide results for different prediction types.</div>
                    <div class="intro-img" v-if="screenWidth > 767"><img src="~@/assets/images/hot-intro-img.png" /></div>
                    <div class="intro-img" v-if="screenWidth <= 767"><img src="~@/assets/images/hot-intro-img-m.png" /></div>
                    <div class="algo-play-box">
                        <h4 class="algo-play-title">Prediction Content Instructions</h4>
                        <div class="algo-play-sub">Predictions for 5 types are provided:</div>
                        <div class="algo-play-item">
                          <p><span>1x2</span><b>Predicts the full-time match result, with a confidence index for reference (more stars indicate higher confidence).</b></p>
                          <p><span>Asian Handicap</span><b>Predicts the full-time result based on the Asian handicap.</b></p>
                          <p><span>Goals Over/Under</span><b>Predicts whether the total goals scored in the 90-minute match will be over or under the specified goal line.</b></p>
                          <p><span>Correct Scores</span><b>Predict the score after 90 minutes, providing the 3 results with the highest algorithm prediction probability.</b></p>
                          <p><span>Goals</span><b>Predict the goals of the whole game, providing the 2 results with the highest algorithm prediction probability.</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
    export default {
        name: 'hotPrediction',
        props: {
            listHotData: {
                type: Array,
                default: () => []
            },
            setting: {
                type: Object,
                default: () => {}
            }
        },

		data(){
			return{
                ishideLeft: false,
                ishideRight: true,

                hotTipsShow: false,
                screenWidth:2000,
            }
        },

        computed: {
        
        },

        mounted(){
            this.screenWidth = window.innerWidth;
            window.addEventListener('resize', this.handleResize);
        },

        methods:{
            // google事件点击统计
            googleEventClick(val){
                let _val = val, _tab = 0;
                
                // goals
                if(_val['predScore'] && _val['predScore']['total']){
                    _tab = 5;
                }
                // correctScores
                if(_val['predScore'] && _val['predScore']['score']){
                    _tab = 4;
                }
                // OverUnder
                if(_val['predDiffer'] && _val['predDiffer']['ou']){
                    _tab = 3;
                }
                // asianHandicap
                if(_val['predDiffer'] && _val['predDiffer']['ah']){
                    _tab = 2;
                }
                // 1x2
                if(_val['predWdl'] || (_val['predDiffer'] && _val['predDiffer']['wdl'])
                ){
                    _tab = 1;
                }

                _tab = this.langConfig.txtLang[this.langConfig.curLang]['PLAY_EVENT'][_tab-1];

                let eventName = 'LS_PC_H_HotMatch_Click';
                if(this.common.isMobile != 4){
                    eventName = 'LS_Webapp_H_HotMatch_Click';
                }

                this.common.googleEvent(eventName, {
                    '玩法': _tab
                });
            },
            // 跳转内页
            toDetails(val){
                let _val = val, _matchId = _val['match']['matchId'], _state = _val['match']['state'], _stateArr = this.liveSate, _tab = 0, _homeName = this.common.formalTitle(_val['match']['homeTeam']['fullName']), _awayName = this.common.formalTitle(_val['match']['awayTeam']['fullName']);

                if(typeof(_val['predScore']) != 'undefined'){
                    //_tab = 9;
                    let _type = _val['predScore']['score'] ? 3 : 4;
                    _tab = this.langConfig.txtLang[this.langConfig.curLang]['TAB_TITLE'][_type];
                }

                if(typeof(_val['predWdl']) != 'undefined'){
                    //_tab = 10;
                    _tab = this.langConfig.txtLang[this.langConfig.curLang]['TAB_TITLE'][0];
                }

                if(typeof(_val['predDiffer']) != 'undefined'){
                    //_tab = 11;
                    let _type = _val['predDiffer']['ah'] ? 1 : 2;
                    _tab = this.langConfig.txtLang[this.langConfig.curLang]['TAB_TITLE'][_type];
                }

                return `/details/${_tab}/${_matchId}/${_homeName}-vs-${_awayName}`;
            },
            
            // 模型显示
            isModelShow(type){
                let _type = type;
                if(typeof(_type) != 'undefined'){
                    return true;
                }
                return false;
            },
            // 指数返回
            oddsCallFn(ot, val, type){
                let _val = val, _type = type;
                if(typeof(_val) == 'undefined'){
                    return '-'
                }

                return this.oddsLuckyChange(ot, _val, _type);
            },

            // 赔率转换
            oddsLuckyChange(ot, val, type2){
                let _val = val, _form = this.setting.oddsForm, _type = ot, _type2 = type2;
                let _typeArr = ['home', 'away', 'over', 'under'];

                // if(_type == 1){
                //   return this.common.oddsFromChange(_val, _form);
                // }

                if(_type == 2 || _type == 3){
                    if(_typeArr.includes(_type2)){
                        _val =  this.common.addValue(_val*1,1);
                    }
                }
                if(_type2 == 'hand' || _type2 == 'total'){
                    return _val;
                }

                return this.common.oddsFromChange(_val, _form);
            },
            // 指数升降
            oddsUd(val, type, hand){ // val-数据, type-指数类型: 0-亚/1-大小/2-欧, hand-指数: 0-主(胜)/1-盘口(平)/2-客(负)
                let current = ['asian','total','threeWay'], prev = ['asianPrev', 'totalPrev', 'threeWayPrev'];
                let handTxt = [['home', 'hand', 'away'],['over', 'total', 'under'],['home', 'draw', 'away']]

                let _val = val, _type = type, _hand = hand, _val1 = 0, _val2 = 0;

                _val1 = _val[current[_type]][handTxt[_type][_hand]]*1; // 当前指数

                if(typeof(_val[prev[_type]]) == 'undefined'){ // 没有上个指数
                    return '';
                }

                _val2 = _val[prev[_type]][handTxt[_type][_hand]]*1; // 上个指数

                if(typeof(_val2) == 'undefined' || _val1 == _val2){
                    return '';
                }

                if(_val2 > _val1){
                    return 'green';
                }

                if(_val2 < _val1){
                    return 'red';
                }
            },
            // 比赛时间
            matchTime(val){
                let _val = val;
                let _tsz = this.setting.tsz;
                let _time = this.common.getDateByArray(_tsz, _val);
                
                _val = '<em>' + this.common.dateStr(_time, 'HH:mm') + '</em>' + this.langConfig.txtLang[this.langConfig.curLang]['MOOTH_SORT'][this.common.dateStr(_time, 'MM')*1 - 1] + ' ' + this.common.dateStr(_time, 'dd');

                return _val;
            },

            // 差异分析球队logo返回
            diffTeamLogo(val, type) { // type-指数类型: 0:欧/1:亚
                let _val = val, _type = type, _homeId = _val['match']['homeTeam']['id'], _awayId = _val['match']['awayTeam']['id'], _result = null;

                if(_type == 0){
                    _result = _val['predDiffer']['wdl'];
                }

                if(_type == 1){
                    _result = _val['predDiffer']['ah'];
                }

                if(_result == 1){
                    return _homeId;
                }else if(_result == 3){
                    return _awayId;
                }else{
                    return '';
                }

            },

            // diffAsian结果返回
            diffAsianResult(val){
                let _val = val;

                if(_val['predDiffer']['ah'] == 1){
                return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][0] + '<em>('+ _val['predDiffer']['ahHand'] +')</em';
                }

                if(_val['predDiffer']['ah'] == 3){
                return this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['WIN'][2] + '<em>('+ (_val['predDiffer']['ahHand'])*-1 +')</em';
                }
            },

            // 大小文本返回
            hpOUTxt(val){
                let  _val = val, _ou = _val['predDiffer']['ou']*1, _ouHand = _val['predDiffer']['ouHand'], _txt = this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['OU_TXT'];

                if(_ouHand > 1){
                    _txt = this.langConfig.index[this.langConfig.curLang]['HOT_PRED']['OU_TXT_S'];
                }

                return _txt[_ou - 1].replace('?1', _ouHand);
            },

            // 上一页
            swipePrev(){
                let scrollLeft = this.$refs.topNewsList.scrollLeft;
                let swiperItem_clientWidth = (this.$refs.swiperItem_0[0].clientWidth + 12)*3;

                this.$set(this.$refs.topNewsList,'scrollLeft',scrollLeft - swiperItem_clientWidth)

                this.ishideRight = true
                if(scrollLeft - swiperItem_clientWidth < 0){
                    this.ishideLeft = false
                }
            },
            // 下一页
            swipeNext(){
                let scrollLeft = this.$refs.topNewsList.scrollLeft
                let scrollWidth = this.$refs.topNewsList.scrollWidth
                let clientWidth = this.$refs.topNewsList.clientWidth
                let swiperItem_clientWidth = (this.$refs.swiperItem_0[0].clientWidth + 12)*3

                this.$set(this.$refs.topNewsList,'scrollLeft',scrollLeft + swiperItem_clientWidth)

                this.ishideLeft = true;
                if(clientWidth + swiperItem_clientWidth + scrollLeft > scrollWidth){
                    this.ishideRight = false
                }
            },

            // 是否显示弹窗
            hotTipsIsShow(){
                if(!this.hotTipsIsShow){
                    let eventName = 'LS_PC_Help_Click';
                    if(this.common.isMobile != 4){
                        eventName = 'LS_Webapp_Help_Click';
                    }

                    this.common.googleEvent(eventName, {
                        '点击位置': '首页-热门比赛'
                    });
                }

                this.hotTipsShow = !this.hotTipsShow;
            },

            //获取屏幕宽度
            handleResize() {
                if(typeof window!='undefined'){
                this.screenWidth = window.innerWidth;
                }
            },
        },

        created(){

        },

        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },

        destroyed() {
        
        },
    }
</script>
<style lang="less" scoped>
@import '~@/style/index/hotPred.less';
</style>


// WEBPACK FOOTER //
// ./src/views/home/components/hotPrediction.vue